import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Workitsatff() {
  return (
    <section
      className="work_it_staff p-100"
      style={{
        background: "linear-gradient(269.71deg, #FFFFFF 0.26%, #FCF8FE 99.77%)",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="resp_order">
            <StaticImage
              src="../../../images/solution/it-staff/work_it_staff.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={594}
              height={536}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <h2>How IT Staff Augmentation Services Work?</h2>
            <p>
              IT staff augmentation is the strategic addition of external IT
              professionals to your existing team through a trusted partner like
              TekRevol. Whether you need a single developer with specialized
              skills or an entire team of engineers, our staff augmentation
              company provides the flexibility to scale workforce quickly and
              efficiently. Eliminates the time-consuming and costly processes of
              sourcing, recruiting, and training, focus on achieving your
              technology goals with the expertise you need.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Workitsatff;
